import {
  RichTextEditor,
} from '@factorialco/f0-react/dist/experimental'

import TextArea from 'modules/core/components/TextArea'
import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'

export const RichTextOrTextArea = ({
  value,
  onChange,
  canUseRichTextEditor,
  richTextEditorLoading,
  editorConfig,
  label,
  placeholder,
  mandatory,
}: {
  value: string | undefined
  onChange: (value: string) => void
  canUseRichTextEditor: boolean
  richTextEditorLoading: boolean
  editorConfig: ReturnType<typeof useRichTextEditor>['editorConfig']
  label: string
  placeholder: string
  mandatory?: boolean
}) => {
  if (richTextEditorLoading) {
    return <RichTextEditor.Skeleton />
  }

  if (canUseRichTextEditor) {
    return (
      <RichTextEditor
        {...editorConfig}
        onChange={(v) => onChange(v?.value ?? '')}
        placeholder={placeholder}
        initialEditorState={{ content: value ?? '' }}
        title={label}
        height="sm"
      />
    )
  }

  return (
    <TextArea
      value={value}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      mandatory={mandatory}
    />
  )
}
